import { createContext, useMemo, useState } from "react";

export const REContext = createContext({
  previousPathURL: 0,
  setPreviousPathURL: () => {},
});

export const REProvider = ({ children }) => {
  const [previousPathURL, setPreviousPathURL] = useState("");
  const value = useMemo(
    () => ({ previousPathURL, setPreviousPathURL }),
    [previousPathURL, setPreviousPathURL], //eslint-disable-line
  );
  return <REContext.Provider value={value}>{children}</REContext.Provider>;
};
